import axios from "axios";
import { GetUserData } from "config/storage";
import { toast } from "react-toastify";

const http = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

const handleUnauthenticatedRequest = () => {
  // redirect to login page
  // window.location.href = "/login";
  // window.location.reload();
  // throw new axios.Cancel("SESSION_TIMEOUT");
};

http.interceptors.request.use(
  function (config) {
    const userData = GetUserData();
    const token = userData?.token;
    if (!!token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const isPaymentResponse = error.request.responseURL.includes("/salesforce/create/payment")
    if (error.response?.status === 401) {
      handleUnauthenticatedRequest();
    }
    if (error.response?.status === 500 && !isPaymentResponse) {
      toast.error("Something went wrong. Please try after sometime.");
    }
    return Promise.reject(error);
  }
);

export default http;
